<script setup lang="ts">
import type { ButtonHTMLAttributes } from "vue";
import type { RouterLinkProps } from "vue-router";
import { useDelegatedProps } from "../../lib/base-props";
import Button, { type ButtonProps } from "./Button.vue";

interface Props
	extends Omit<ButtonProps, "asChild" | "as">,
		RouterLinkProps,
		/* @vue-ignore */ Omit<ButtonHTMLAttributes, keyof ButtonProps | keyof RouterLinkProps> {}

const props = defineProps<Props>();

const delegatedProps = useDelegatedProps(props, [
	"to",
	"activeClass",
	"exactActiveClass",
	"replace",
	"viewTransition",
	"custom",
	"ariaCurrentValue",
]);
</script>

<template>
	<Button :class="props.class" v-bind="delegatedProps" asChild>
		<RouterLink
			:to="props.to"
			:activeClass="props.activeClass"
			:exactActiveClass="props.exactActiveClass"
			:replace="props.replace"
		>
			<slot />
		</RouterLink>
	</Button>
</template>
